// WhatsAppFloat.js
import React, { useState, useEffect, useRef } from "react";
import { FaWhatsapp, FaUser } from "react-icons/fa";
import { IoClose } from "react-icons/io5";
import "../css/WspButton.css";

const WhatsAppFloat = () => {
  const [showBox, setShowBox] = useState(false);
  const closeTimer = useRef(null);

  // Auto-open on page load + sound + auto close
  useEffect(() => {
    const audio = new Audio("/notification.mp3");
    audio.volume = 0.7;
    audio.play().catch(() => {});

    setShowBox(true);

    closeTimer.current = setTimeout(() => {
      setShowBox(false);
    }, 10000);

    return () => clearTimeout(closeTimer.current);
  }, []);

  // Hover to show popup again
  const handleHoverOpen = () => {
    clearTimeout(closeTimer.current);
    setShowBox(true);
  };

  // Close button
  const handleClose = () => {
    setShowBox(false);
    clearTimeout(closeTimer.current);
  };

  return (
    <div className="whatsapp-wrapper" onMouseEnter={handleHoverOpen}>
      
      {/* Popup Box */}
      {showBox && (
        <div className="whatsapp-hover-box">
          
          {/* ❌ Close Button */}
          <button
            className="close-btn"
            onClick={handleClose}
            style={{
              position: "absolute",
              top: "6px",
              right: "6px",
              background: "transparent",
              border: "none",
              cursor: "pointer",
              color: "#fff",
              fontSize: "18px",
            }}
          >
            <IoClose />
          </button>

          <div className="whatsapp-header">
            <div
              style={{
                width: "32px",
                height: "32px",
                borderRadius: "50%",
                background: "#fff",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginRight: "10px",
              }}
            >
              <FaUser size={18} color="#075e54" />
            </div>

            <span className="name">Peregrinee</span>
          </div>

          <div className="whatsapp-message">Want to contact with us?</div>

          <a
            href="https://wa.me/9875645936?text=Hi!%20Can%20we%20schedule%20a%20meeting?"
            target="_blank"
            rel="noopener noreferrer"
            className="chat-button"
          >
            Chat
          </a>
        </div>
      )}

      {/* Floating Main Button */}
      <a
        href="https://wa.me/9875645936?text=Hi!%20Can%20we%20schedule%20a%20meeting?"
        className="whatsapp-float"
        target="_blank"
        rel="noopener noreferrer"
      >
        <FaWhatsapp size={28} />
      </a>
    </div>
  );
};

export default WhatsAppFloat;
